import { createTheme } from '@mui/material';
import palette, {
  ControllerChartColor,
  ControllerDataGridContainerColor,
  ControllerInputLabelColor,
  ControllerLineChartColor,
  ControllerThemeColor,
} from '../palette';
import { ControllerDateRangePickerStyles } from '../mason-components';
import { ControllerFont, ControllerFontWeight, HTML_ELEMENT_FONT_SIZE } from '../fonts';

// declare module '@mui/material/styles' {
//   // augmenting `createTheme`
//   interface PaletteOptions {
//     successAlt?: PaletteOptions['primary'];
//   }
// }

const theme = createTheme({
  mason: {
    chart: {
      border: {
        light: String(ControllerChartColor.BorderColorLight),
        main: String(ControllerChartColor.BorderColor),
      },
      label: {
        text: String(ControllerChartColor.LabelColorFg),
      },
      tooltip: {
        font: ControllerFont.Body400R,
        main: String(ControllerChartColor.TooltipColorBg),
        text: String(ControllerChartColor.TooltipColorFg),
      },
    },
    dataGridContainer: {
      header: {
        border: String(ControllerDataGridContainerColor.HeaderBorder),
        main: String(ControllerDataGridContainerColor.HeaderBg),
        menuItem: {
          icon: String(ControllerDataGridContainerColor.HeaderMenuItemIcon),
        },
        text: {
          error: String(ControllerDataGridContainerColor.HeaderFgError),
          main: String(ControllerDataGridContainerColor.HeaderFg),
        },
      },
      pagination: {
        label: {
          font: ControllerFont.Heading250M,
        },
        activePage: {
          font: ControllerFont.Heading300B,
        },
      },
    },
    dateRangePicker: {
      caption: {
        font: ControllerDateRangePickerStyles.DayOfMonthHeaderFont,
        text: ControllerDateRangePickerStyles.DayOfMonthHeaderColorFg,
      },
    },
    lineChart: {
      lineSeries: {
        1: String(ControllerLineChartColor.LineSeries1ColorFg),
      },
      pointSeries: {
        1: String(ControllerLineChartColor.PointSeries1ColorFg),
      },
    },
    modal: {
      requiredLabel: {
        font: ControllerFont.Body300R,
        indicator: String(ControllerInputLabelColor.RequiredIndicatorFg),
        text: String(ControllerInputLabelColor.DefaultFg),
      },
      title: {
        font: ControllerFont.Heading400R,
      },
    },
    sectionedMenu: {
      font: ControllerFont.Decor200M,
    },
    successAlt: String(ControllerThemeColor.SuccessAlt),
  },
  palette,
  shape: { borderRadius: 2 },
  typography: {
    fontWeightBold: ControllerFontWeight.Bold,
    fontWeightRegular: ControllerFontWeight.Regular,
    fontWeightMedium: ControllerFontWeight.Medium,
    fontWeightLight: ControllerFontWeight.Light,
    htmlFontSize: HTML_ELEMENT_FONT_SIZE,
    h5: ControllerFont.Heading400B,
    h6: ControllerFont.Heading250M,
  },
});

export default theme;
